import { LandingRewardsRepository } from '@/core/domain/landing-rewards/repositories/landing-rewards.repository';
import { GetLandingRewardsUseCase } from '@/core/domain/landing-rewards/usecases/getLandingRewards.usecase';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LandingRewardsImplRepository } from './landing-rewards-impl.repositry';

const GetLandingRewardsUseCaseFactory = (
    landingRewardsRepository: LandingRewardsRepository,
) => new GetLandingRewardsUseCase(landingRewardsRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: GetLandingRewardsUseCase,
            useFactory: GetLandingRewardsUseCaseFactory,
            deps: [LandingRewardsRepository],
        },
        {
            provide: LandingRewardsRepository,
            useClass: LandingRewardsImplRepository,
        },
    ],
})
export class LandingRewardsDataModule {}
